import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {CriminalCoruptionQueryResponse, Tipidkor, TipidkorQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_BASE_API_URL
const USER_URL = `${API_URL}/report/tipidkor`
const GET_CRIMINAL_CORRUPTION_URL = `${API_URL}/criminal-corruption`

const getTipidkor = (query: string): Promise<TipidkorQueryResponse> => {
  return axios.get(`${USER_URL}?${query}`).then((d: AxiosResponse<TipidkorQueryResponse>) => d.data)
}

const getTipidkorById = (id: ID): Promise<Tipidkor | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<Tipidkor>>) => response.data)
    .then((response: Response<Tipidkor>) => response.data)
}

const createTipidkor = (user: Tipidkor): Promise<Tipidkor | undefined> => {
  return axios
    .post(`${USER_URL}`, user)
    .then((response: AxiosResponse<Response<Tipidkor>>) => response.data)
    .then((response: Response<Tipidkor>) => response.data)
}

const updateTipidkor = (user: Tipidkor): Promise<Tipidkor | undefined> => {
  return axios
    .put(`${USER_URL}/${user.id}`, user)
    .then((response: AxiosResponse<Response<Tipidkor>>) => response.data)
    .then((response: Response<Tipidkor>) => response.data)
}

const deleteTipidkor = (userId: ID): Promise<void> => {
  return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}

const verifyTipidkor = (userId: ID): Promise<void> => {
  return axios.put(`${USER_URL}/verify/${userId}`).then(() => {})
}

const rejectTipidkor = (userId: ID): Promise<void> => {
  return axios.put(`${USER_URL}/reject/${userId}`).then(() => {})
}

const getCriminalCorruptionSelect = (query: string): Promise<CriminalCoruptionQueryResponse> => {
  return axios
    .get(`${GET_CRIMINAL_CORRUPTION_URL}/select?${query}`)
    .then((d: AxiosResponse<CriminalCoruptionQueryResponse>) => d.data)
}

const setDraftTipidkor = (id: ID): Promise<void> => {
  return axios.put(`${USER_URL}/set-draft/${id}`).then(() => {})
}

export {
  getTipidkor,
  getTipidkorById,
  createTipidkor,
  updateTipidkor,
  deleteTipidkor,
  getCriminalCorruptionSelect,
  verifyTipidkor,
  rejectTipidkor,
  setDraftTipidkor,
}
